import React, { useState, useEffect } from 'react'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import './grid-list-signature.css'
import moment from 'moment'
import { useMediaQuery } from '@material-ui/core'
import { Document, Page } from "react-pdf";

import DialogAcceptMultiSignatureAutografaCustom from './dialog-accept-multi-signature-autografa-custom'
import { GridHLPure } from '..'
const signerCellHeader = ({ title }) => <span className='signerCellHeader' >{title}</span>
const signerCellDate = ({ dataItem, field }) => <td className='signerCellDate' >{dataItem[field]}</td>
const signerCell = ({ dataItem, field }) => <td className='signerCell' > {dataItem[field]}</td>

export default function GridListSignatures({ signatures, ...props }) {
  const [currentPage, setCurrentPage] = useState(0)
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pager, setPager] = useState(1);
  const [tempImgPages, setTempImgPages] = useState({});
  const [currentIndex, setCurrentIndex] = useState(null);

  const [selectedSignature, setSelectedSignature] = useState();
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    let deleteItem = currentPage - 1
    let temp = { ...tempImgPages }
    delete temp[deleteItem]
    setTempImgPages(temp)
  }, [currentPage])

  const isShowPage = useMediaQuery('(min-width:430px)')
  let pdfFile = "data:application/pdf;filename=file.pdf;base64," + props.signRequestPDF;
  let pagesNumTemp = [...Array(numPages)];

  const onDocumentLoadSuccess = (params) => {
    setNumPages(params.numPages);
    setPageNumber(params.numPages);
    setPager(params.numPages);
  };

  const [currentSystem, setCurrentSystem] = useState("");
  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  const isTouchScreendevice = () =>
    "ontouchstart" in window || navigator.maxTouchPoints;
  if (isTouchScreendevice()) isMobile = true;
  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  const onClickFirmar = () => {
    if (isMobile && selectedSignature.imgSignature) {
      let temp = signatures.map((i) => {
        if (selectedSignature.index === i.index) {
          setCurrentIndex(i.index);
          return {
            date: null,
            imgSignature: null,
            index: i.index,
            page: "",
            savePostion: null,
          };
        } else return i;
      });
      props.insertSignByCoordinates(temp);
      let deleteItem = selectedSignature.page - 1;
      let tempObj = { ...tempImgPages };
      delete tempObj[deleteItem];
      setTempImgPages(tempObj);
    }
    setShowDialog(true);
  }

  const toggleDialogAccept = () => {
    let val = !showDialog;
    if (!val && currentIndex === selectedSignature.index) {
      setCurrentIndex(null);
      props.insertSignByCoordinates(signatures);
      let deleteItem = selectedSignature.page - 1;
      let tempObj = { ...tempImgPages };
      delete tempObj[deleteItem];
      setTempImgPages(tempObj);
    }
    setShowDialog(val);
  };

  useEffect(() => {
    if (!selectedSignature || !Object.keys(selectedSignature).length) return;
    onClickFirmar();
  }, [selectedSignature])


  signatures = signatures.map(item => ({
    ...item,
    date: item.date ? item.date : moment(new Date()).format('YYYY-MM-DD')
  }));

  return (
    <React.Fragment>
      {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ?
        <>
          <GridHLPure
            {...props}
            skip={0}
            take={6}
            dataGrid={signatures.map(i => i.index === selectedSignature?.index ? ({ ...i, savePostion: null }) : i)}

            titleRow1={"Fecha"}
            fieldRow1={"date"}

            column2Status={false}

            columnThree={true}
            titleRow3={"Página firmada"}
            fieldRow3={"page"}

            columnFour={true}
            titleRow4={"Acciones"}
            iconOneActive
            labelOneActions={"Firmar"}
            onSelectedItem={setSelectedSignature}
            setNameComponentUser={() => { }}
            setShowDetails={() => { }}
            activeDialog1={true}
            btnOpenDialog1={(dataItem, _) => setSelectedSignature(dataItem)}
          />

          {
            showDialog && !props?.showLoadingRequesting &&
            props?.currentSignaturetype?.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && <DialogAcceptMultiSignatureAutografaCustom
              {...props}
              toggleDialogAccept={toggleDialogAccept}
              visibleAccept={showDialog}
              signatures={signatures.map(i => i.index === selectedSignature?.index ? ({ ...i, savePostion: null }) : i)}
              dataItem={selectedSignature}
              numPages={numPages}
              pageNumber={pageNumber}
              pager={pager}
              tempImgPages={tempImgPages}
              setCurrentPage={setCurrentPage}
              currentIndex={currentIndex}
              setCurrentIndex={setCurrentIndex}
              setTempImgPages={setTempImgPages}
            />
          }


          {/* <Grid
        className='listSignerSignatures'
        data={signatures.map(item => ({
          ...item,
          date: item.date ? item.date : moment(new Date()).format('YYYY-MM-DD')
        }))}
        resizable
        reorderable
        style={{ marginTop: '32px' }}
      >
        {isShowPage && <GridColumn field='date' title={'Fecha'} width='auto' cell={signerCellDate} headerCell={signerCellHeader} />}
        {isShowIndex && <GridColumn className={'index-sigantures'} field='index' title={'Firma'} width='auto' cell={signerCell} headerCell={signerCellHeader} />}
        <GridColumn field='page' title={'Página'} width='auto' cell={signerCell} headerCell={signerCellHeader} />
        <GridColumn title={'Acciones'} width='auto' headerCell={signerCellHeader}
          cell={({ dataItem }) => (
            <DialogAcceptMultiSignatureAutografaCustom
              {...props}
              signatures={signatures.map(i => i.index === dataItem.index ? ({ ...i, savePostion: null }) : i)}
              dataItem={dataItem}
              numPages={numPages}
              pageNumber={pageNumber}
              pager={pager}
              tempImgPages={tempImgPages}
              setCurrentPage={setCurrentPage}
              currentIndex={currentIndex}
              setCurrentIndex={setCurrentIndex}
              setTempImgPages={setTempImgPages}
            />
          )}
        />
      </Grid> */}
          <div style={{ display: "none" }}>
            <Document file={props.result ?? pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
              <React.Fragment>
                {pagesNumTemp.map((item, index) => {
                  return (
                    <React.Fragment>
                      <Page
                        className={`import-pdf-page-${index + 1}`}
                        pageNumber={index + 1}
                        onRenderSuccess={() => {
                          const importPDFCanvas = document.querySelector(
                            `.import-pdf-page-${index + 1} canvas`
                          );
                          const pdfAsImageSrc = importPDFCanvas.toDataURL();
                          if (!tempImgPages[index]) {
                            setTempImgPages({
                              ...tempImgPages,
                              [index]: pdfAsImageSrc,
                            });
                          }
                        }}
                      />
                    </React.Fragment>
                  )
                })}
              </React.Fragment>
            </Document>
          </div>
        </>
        : null}
    </React.Fragment>
  )
}


